import { ACTION_TYPES } from '../constants';

const tasksLoadingReducer = (state = true, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_TASKS_REQUEST:
      return true;
    case ACTION_TYPES.GET_TASKS_REQUEST_SUCCESS:
    case ACTION_TYPES.GET_TASKS_REQUEST_ERROR:
      return false;
    default: {
      return state;
    }
  }
};

export default tasksLoadingReducer;
